import nftAbi from "./abis/nft.json";

const abis = {
  "nft": nftAbi
};

export default abis;
